module.exports = BD.Model.extend({
    reportType: BD.attr('string'),
    name: BD.attr('string'),
    normalBalance: BD.attr('side')
})
